export const themes = {
  default: {
    thRoot:
      'border-1 border-dashed border-grey flex items-center justify-center px-20 text-grey relative rounded-12 min-h-90',
    thNumber: 'absolute start-0 flex inset-y-0 italic items-center leading-1 mx-20 text-76',
    thLabel: 'flex-1 font-bold text-center text-16 text-black px-10',
    thRootFilled: 'border-1 border-lightGrey flex rounded-12 shadow min-h-90',
    thChildren: 'flex-1 p-10 w-9/10',
    thClear: 'border-0 border-s-1 border-solid border-lightGrey leading-0 p-10',
    thClearIconSize: '0.625rem',
  },
};
